<div class="card grupo-estacao-container">
    <p-toolbar styleClass="mb-4 grupo-estacao-toolbar">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Novo" icon="pi pi-plus" class="p-button-success mr-2"
                (click)="openNew()"></button>
            <!-- <button pButton pRipple label="Novo" [disabled]="permissaoService.can('estacoes_inserir') == false"
                icon="pi pi-plus" class="p-button-success mr-2" (click)="openNew()"></button> -->
        </ng-template>


    </p-toolbar>

    <div class="grupo-estacao-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['id','nome','empresa_nome']"
            [scrollable]="true" [scrollHeight]="scrollHeight">


        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                <h5 class="p-m-0">Grupos</h5>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Código
                </th>
                <th>Nome
                </th>
                <th>Empresa
                </th>
                <th>Editar</th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>

                <td><span class="p-column-title negrito">Nome: </span>{{dt.nome}}</td>
                <td><span class="p-column-title negrito">Empresa: </span>{{dt.empresa_nome || '-'}}</td>
                <td style="text-align: center;">
                    <span class="p-column-title negrito">Editar: </span>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                        (click)="edit(dt)"></button>
                    <!-- <button pButton pRipple [disabled]="permissaoService.can('estacoes_editar') == false"
                        icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                        (click)="edit(dt)"></button> -->
                </td>



            </tr>
        </ng-template>

        </p-table>
    </div>
</div>
<p-dialog header="Grupo" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '75vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <p-tabView>
            <p-tabPanel header="Dados principais">
                <form [formGroup]="form" class="p-fluid grid">

                    <div class="field col-12 md:col-12 xl:col-12">
                        <input type="checkbox" class="form-check-input" id="ativo" formControlName="ativo">
                        <label class="form-check-label" for="ativo">Ativo</label>
                    </div>

                    <div class="field col-12 md:col-12 xl:col-12 mt-5">
                        <p-floatlabel>
                            <input type="text" id="nome" pInputText formControlName="nome" class="w-full">
                            <label for="nome">Nome</label>
                        </p-floatlabel>
                    </div>


                </form>
            </p-tabPanel>
            <p-tabPanel header="Estações">
                <div *ngFor="let item of array_estacoes" class="p-fluid grid col-12">
                    <div class="p-fluid grid col-12">


                        <div class="field col-12 md:col-12 xl:col-4 mt-5">
                            <p-floatlabel>
                                <p-dropdown inputId="estacao_id" appendTo="body" [filter]="true" filterLocale="pt-BR"
                                    [options]="dropDownEstacoes" [(ngModel)]="item.estacao_id" styleClass="w-full">
                                </p-dropdown>
                                <label for="estacao_id">Estação</label>
                            </p-floatlabel>
                        </div>



                        <div class="col-12 md:col-12 xl:col-2">
                            <button pButton pRipple icon="pi pi-minus" (click)="removeEstacao(item)" label="Remover"
                                type="button" class="p-button-raised p-text-bold btn-lg p-button-danger"></button>
                        </div>

                        <div class="col-12 ">
                            <hr>
                        </div>

                    </div>
                </div>

                <div class="col-12 md:col-12 xl:col-4">
                    <button pButton pRipple icon="pi pi-plus" (click)="addEstacao()" label="Inserir estação"
                        type="button" class="p-button-raised p-text-bold btn-lg p-button-success"></button>
                </div>
            </p-tabPanel>
        </p-tabView>



    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>
